import {Component, OnDestroy, OnInit} from '@angular/core';
import {UserRegulationsService} from "./user-regulations.service";
import {Subscription} from "rxjs";
import {UserRulesService} from "../user-rules/user-rules.service";

@Component({
  selector: 'pbc-user-regulations',
  templateUrl: './user-regulations.component.html',
  styleUrls: ['./user-regulations.component.scss']
})
export class UserRegulationsComponent implements OnInit, OnDestroy {

  showUserRegulations: boolean = false;
  private subscription: Subscription;

  constructor(private userRegulationsService : UserRegulationsService) { }

  ngOnInit() {
    this.subscription = this.userRegulationsService.showUserRegulations.subscribe((value : boolean) => {
      console.log(value);
      this.showUserRegulations = value;
    })
  }

  ngOnDestroy(): void {
    this.subscription = null;
  }

  closeUserRegulationsClick() {
    this.showUserRegulations = false;
  }
}
